<template>
	<div>
		<ModalNewMember ref="ModalNewMember" @resend="resend"></ModalNewMember>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Member Baru Ecommerce</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent v-if="dropfilter" @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined >
			<v-data-table loading disable-pagination :headers="headers" :items="listMember" :search="search" hide-default-footer :options.sync="option" :server-items-length="paginationMember.total_data" class="">
				<template v-slot:item.action="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="" fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on" @click.stop="showRegistration(item)">
								<v-icon dark>mdi-pencil</v-icon>
							</v-btn>
						</template>
						<span>Registrasi Ulang</span>
					</v-tooltip>
				</template>
				<template v-slot:item.register_sponsor_code="{ item }">
					<div class="pt-2">{{ item.register_sponsor_code }}</div>
				</template>
				<template v-slot:item.register_member_name="{ item }">
					<div class="pt-2">{{ item.register_member_name }}</div>
				</template>
				<template v-slot:item.register_member_phone="{ item }">
					<div class="pt-2">{{ item.register_member_phone }}</div>
				</template>
				<template v-slot:item.register_member_email="{ item }">
					<div class="pt-2">{{ item.register_member_email }}</div>
				</template>
				<template v-slot:item.register_member_province_name="{ item }">
					<div class="pt-2">{{ item.register_member_province_name }}</div>
				</template>
				<template v-slot:item.register_status="{ item }">
					<div class="pt-2">{{ item.register_status }}</div>
				</template>
				<template v-slot:item.register_datetime="{ item }">
					<div class="pt-2">{{ item.register_datetime | tanggalIna }}</div>
				</template>
				<template v-slot:item.register_platform="{ item }">
					<div class="pt-2">{{ item.register_platform }}</div>
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!paginationMember">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5" v-if="paginationMember">
			<v-row>
				<v-col cols="11" md="11" class="py-0 d-flex justify-space-between">
					<span>Total {{paginationMember.total_data | toNumber}} Data</span>
					<v-pagination v-model="page" :length="paginationMember.total_page" @input="changePage" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="1" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" @input="changeLimit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import filterComponent from '@/components/Filter'
import ModalNewMember from './components/ModalNewMember'

const listStatus = ['waiting', 'pending', 'registered'];

const listPlatform = ['pos', 'ecommerce', 'partner'];

export default {
	inject: ['theme'],
	components: {
		filterComponent, ModalNewMember
	},
	data() {
		return {
			sortBy: 'register_id',
			sortDir: 'DESC',
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Aksi', align: 'center', value: 'action'},
			{ text: 'Kode Sponsor', align: 'start', value: 'register_sponsor_code'},
			{ text: 'Nama Member', align: 'start', value: 'register_member_name'},
			{ text: 'Nomor Handphone', value: 'register_member_phone', sortable: false },
			{ text: 'Email', value: 'register_member_email'},
			{ text: 'Area Mitra', value: 'register_member_province_name'},
			{ text: 'Status Registrasi', value: 'register_status'},
			{ text: 'Tanggal Transaksi', value: 'register_datetime'},
			{ text: 'Platform', value: 'register_platform', sortable: true },
			],
			params:[],
			isLoading: false,
			filterData: [{
				type: 'text',
				label: 'Kode Sponsor',
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'register_sponsor_code'
				}
			}, {
				type: 'text',
				label: 'Nama Member',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'register_member_name'
				}
			}, {
				type: 'number',
				label: 'Nomor Hp',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'register_member_phone'
				}
			}, {
				type: 'text',
				label: 'Email',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'register_member_email'
				}
			}, {
				type: 'selection',
				label: 'Status Registrasi',
				item: listStatus,
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'register_status'
				}
			}, {
				type: 'selection',
				label: 'Platform',
				item: listPlatform,
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'register_platform'
				}
			},
			],
		}
	},
	computed: {
		...mapState(['filterParams']),
		...mapState('ecommerceMember', ['listMember', 'paginationMember', 'detailCustomer']),
	},
	methods: {
		...mapActions('ecommerceMember', ['getNewMember', 'exportNewMember', 'resendRegistration']),
		...mapMutations(['setFilter']),
		...mapMutations('ecommerceMember', ['clearDataMember']),

		showRegistration(item) {
			this.$refs.ModalNewMember.defineParams(item)
			this.$refs.ModalNewMember.showModal()
		},
		async resend(data) {
			let resend = await this.resendRegistration(data)
			if (resend == true)
				this.$refs.ModalNewMember.hideModal()
		},
		getData() {
			this.getNewMember(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		exportData() {
			this.exportNewMember(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		async onResetFilter() {
			this.params = []
			this.getData()
		},
	},
	beforeDestroy(){
		this.clearDataMember()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Member Baru Ecommerce`)
		await this.getData()

		await this.setFilter(this.filterData)
	},
};
</script>